import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/sub-draw-history")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "98e06074-b14f-5a83-ace9-c3c1d59449e8" }, replace: true });
  },
  component: () => null,
});
